/**
 * Internal SSO client offer route — /offers/:offerId/client
 *
 * Shows the latest PUBLISHED version of an offer to an authenticated
 * client user (Phase 2 SSO only; Phase 3 token access is CU-86c8zc6yk).
 *
 * Renders WhatChangedPanel when GET .../client-view returns a non-null diff;
 * accepts with "Akceptuję wersję v{N}" wired to POST .../versions/:versionId/accept.
 *
 * Traceability: REQ-7.6 → offer-versioning-diff / Client "What Changed" Panel UI,
 *               Version-Specific Accept Button UI
 */
import * as React from 'react';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ClientOfferPage, ClientOfferPageLoading, ClientOfferPageError } from '@ooh/screens';
import { useNavigate } from '@tanstack/react-router';
import { PageTitleContext } from '../__root';

export const Route = createFileRoute('/offers/$offerId/client')({
  pendingComponent: ClientOfferPageLoading,
  errorComponent: () => <ClientOfferPageError />,
  component: ClientOfferRoute,
});

function ClientOfferRoute() {
  const { offerId } = useParams({ from: '/offers/$offerId/client' });
  const { setPageTitle } = React.useContext(PageTitleContext);
  const { t } = useTranslation('offers');
  const navigate = useNavigate();

  React.useEffect(() => {
    setPageTitle(t('clientOffer.pageTitle'));
  }, [setPageTitle, t]);

  return (
    <ClientOfferPage
      offerId={offerId}
      onOpenUnitDetail={(mediaUnitId, options) =>
        void navigate({
          to: '/offers/$offerId/units/$unitId',
          params: { offerId, unitId: String(mediaUnitId) },
          search:
            options?.fromVersionId != null
              ? { from: `version:${options.fromVersionId}` }
              : undefined,
        })
      }
    />
  );
}
